'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('speechprofileen', {
        url: '/speechprofileen',
        template: '<speechprofileen></speechprofileen>'
    });
}



// WEBPACK FOOTER //
// ./client/app/speechprofileen/speechprofileen.routes.js